import React from 'react';
import { Row } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { safeExtractFromObject } from '../../helpers/helpers';

import BorderlessButton from '../buttons/BorderlessButton';

import colors from '../../constants/Colors';

export default function DateRangePickerButtons({ left, onClick, style = {} }) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  return (
    <Row justify='center' align='middle'>
      <BorderlessButton
        style={{ width: 30,
          backgroundColor: hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_DARK_YELLOW,
          padding:0,
          borderRadius:4,
          ...style
        }}
        iconNode={
          left
          ? <LeftOutlined className='date-range-picker-icon'/>
          : <RightOutlined className='date-range-picker-icon'/>
        }
        onClick={onClick}
      />
    </Row>
  );
}

DateRangePickerButtons.propTypes = {
  left: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
};

DateRangePickerButtons.defaultProps = {
  style: {},
};
